<template>
    <nav>
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <v-row>
        <v-col cols="11" class="mx-auto">
          <p
            :class="
              mobile()
                ? 'text-h5 font-weight-bold ml-16 mr-16'
                : 'text-h5 font-weight-bold'
            "
            :align="mobile() ? 'center' : 'left'"
          >
            {{ $t("spaceConnectionsTitle") }}
          </p>
          <p class="text-body-1 greytext--text d-none d-sm-block">
            {{ $t("spaceConnectionsText") }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="11" class="mx-auto">
          <v-row>
            <v-col cols="12" md="6" lg="4" v-if="productPlan.attributes && productPlan.attributes.public_api == 1">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    router
                    to="/space/api"
                    data-testid="connections-api-card"
                    rounded="xxl"
                    max-width="400"
                    height="150"
                    class="mx-auto mx-md-0 pa-4 pb-8 pointer"
                    :elevation="hover ? 8 : 5"
                  >
                    <v-card-title class="font-weight-bold no-break">
                      {{ $t("settingsAPI") }}
                    </v-card-title>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
            <v-col cols="12" md="6" lg="4" v-if="productPlan.attributes && productPlan.attributes.sso == 1">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    router
                    to="/space/saml"
                    data-testid="connections-saml-card"
                    rounded="xxl"
                    max-width="400"
                    height="150"
                    class="mx-auto mx-md-0 pa-4 pb-8 pointer"
                    :elevation="hover ? 8 : 5"
                  >
                    <v-card-title class="font-weight-bold no-break">
                      {{ $t("settingsSAML") }}
                    </v-card-title>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
            <v-col cols="12" md="6" lg="4" v-if="productPlan.attributes && productPlan.attributes.planday_integration == 1">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    router
                    to="/space/planday-users"
                    data-testid="connections-planday-card"
                    rounded="xxl"
                    max-width="400"
                    height="150"
                    class="mx-auto mx-md-0 pa-4 pb-8 pointer"
                    :elevation="hover ? 8 : 5"
                  >
                    <v-card-title class="font-weight-bold no-break">
                      {{ $t("settingsPlanday") }}
                    </v-card-title>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
            <v-col cols="12" md="6" lg="4" v-if="productPlan.attributes && productPlan.attributes.eduadmin_integration == 1">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    router
                    to="/space/eduadmin-settings"
                    data-testid="connections-eduadmin-card"
                    rounded="xxl"
                    max-width="400"
                    height="150"
                    class="mx-auto mx-md-0 pa-4 pb-8 pointer"
                    :elevation="hover ? 8 : 5"
                  >
                    <v-card-title class="font-weight-bold no-break">
                      {{ $t("settingsEduAdmin") }}
                    </v-card-title>
                  </v-card>
                </template>
              </v-hover>
            </v-col>

            <v-col cols="12" md="6" lg="4" v-if="productPlan.attributes ">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    router
                    to="/space/fortnox-settings"
                    data-testid="connections-fortnox-card"
                    rounded="xxl"
                    max-width="400"
                    height="150"
                    class="mx-auto mx-md-0 pa-4 pb-8 pointer"
                    :elevation="hover ? 8 : 5"
                  >
                    <v-card-title class="font-weight-bold no-break">
                      {{ $t("settingsFortnox") }}
                    </v-card-title>
                  </v-card>
                </template>
              </v-hover>
            </v-col>

            <v-col cols="12" md="6" lg="4" v-if="productPlan.attributes ">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    router
                    to="/space/visma-settings"
                    data-testid="connections-visma-card"
                    rounded="xxl"
                    max-width="400"
                    height="150"
                    class="mx-auto mx-md-0 pa-4 pb-8 pointer"
                    :elevation="hover ? 8 : 5"
                  >
                    <v-card-title class="font-weight-bold no-break">
                      {{ $t("settingsVisma") }}
                    </v-card-title>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </nav>
  </template>
  <script>
  import AlertMessages from "../../components/AlertMessages";
  import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
  
  export default {
    components: {
      AlertMessages,
    },
    mixins: [repeatedMethodsMixin],
    data() {
      return {
        alertType: "",
        alertMsg: "",
        alertValue: false,
        loadingData: false,
        spaceId: window.$cookies.get("space_id"),
        domain: process.env.VUE_APP_DOMAIN
      };
    },
    computed: {
      productPlan() {
        return this.$store.state.productPlan;
      },
    },
  };
  </script>
<style lang="css" scoped>
    .pointer {
        cursor: pointer;
    }
</style>